/**
 * SlxControls 1.2.41 ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2025 Selerix Systems, Inc. All Rights Reserved.
 */
(function (global) {
	'use strict';

	/*
	 * slx.core
	 * Required for all slxControls.
	 * Every control should implement a "value" and/or "text" function as needed.
	 */
	if (global.SlxControl) { return; }

	// factory function
	var SlxControl = function (selector, context) {
		return new SlxControl.slx.init(selector, context);
	};

	// update prototype with default props for all instances
	SlxControl.slx = SlxControl.prototype = {
		constructor: SlxControl,
		version: '1.2.41',
		scriptpath: '',
		selector: '',
		length: 0
	};

	// on document ready local vars
	var readyList = [];
	var readyFired = false;
	var readyListeners = false;
	// document ready handler
	var ready = function() {
		if (readyFired) { return; }
		readyFired = true;
		// execute all queued scripts
		for (var r = 0; r < readyList.length; r++) {
			readyList[r]();
		}
		readyList = [];
	};

	// ready state change handler
	var readyStateChange = function() {
		if (document.readyState === 'complete') {
			ready();
		}
	};

	// handler to determine when document is ready
	var whenReady = function(fn) {
		if (typeof fn !== 'function') { return; }
		if (readyFired) {
			// document is already ready. run script immediately
			setTimeout(fn, 1);
			return;
		} else {
			// add to ready queue
			readyList.push(fn);
		}

		// event listeners
		if (document.readyState === 'complete') {
			// execute ready queue
			ready();
		} else if (!readyListeners) {
			if (document.addEventListener) {
				// modern browsers
				document.addEventListener('DOMContentLoaded', ready, false);
				window.addEventListener('load', ready, false);
			} else {
				// old browsers
				document.attachEvent('onreadystatechange', readyStateChange);
				window.attachEvent('onload', ready);
			}
			readyListeners = true;
		}
	};

	// SLX init and constructor
	SlxControl.slx.init = function (selector, context) {
		// validate argument types
		if (typeof selector === 'function') {
			// execute script when document ready
			whenReady(selector);
			return this;
		} else if (typeof selector === 'object') {
			// wrap element in SlxControl container
			return SlxControl.create(selector);
		} else if (typeof selector === 'string' && selector.startsWith('<') && selector.endsWith('>')) {
			// create new tag
			var tag = selector.replace(/[<\/]/g, '').replace(/[>]/g, ' ').split(' ')[0];
			return SlxControl.create(tag);
		}

		// set initial props
		this.selector = selector;
		this._elements = [];

		// query DOM for matching elements by selector
		if (selector) {
			var list = (context || document).querySelectorAll(this.selector);
			for (var i = list.length; i--; this._elements.unshift(list[i]));
		}

		// determine elements
		var length = this._elements ? this._elements.length : 0;
		this._element = length > 0 ? this._elements[0] : null;

		// convert to array and merge props
		var arr = [];
		SlxControl.extend(arr, SlxControl.slx);
		Array.prototype.push.apply(arr, this._elements);
		
		return SlxControl.extend(arr, this);
	};

	// utils for extending objects
	SlxControl.extend = SlxControl.slx.extend = function(obj, ext) {
		var o = obj, e = ext;
		// merging object into this object
		if (ext === void 0) {
			o = this;
			e = obj;
		}

		// do object merge
		for (var p in e) {
			o[p] = e[p];
		}

		return o;
	}

	// slx extensions
	SlxControl.slx.extend({
		// theme types
		themes: {
			0: 'default',
			1: 'success',
			2: 'info',
			3: 'warning',
			4: 'danger'
		},
		// register control
		register: function(control, instance) {
			if (typeof instance === 'function' && typeof SlxControl.slx[control] !== 'function') {
				SlxControl.slx[control] = instance;
			}
		},
		// show element
		show: function (delay, callback) {
			if (this._element) {
				var d = delay || 0, self = this;
				// clear display to show hidden
				setTimeout(function () {
					self._element.style.display = '';
					// do callback
					if (typeof callback === 'function') {
						callback.apply(self._element);
					}
				}, d);
			}
			return this;
		},
		// hide element
		hide: function (delay, callback) {
			if (this._element) {
				var d = delay || 0, self = this;
				// hide display of element
				setTimeout(function () {
					self._element.style.display = 'none';
					// do callback
					if (typeof callback === 'function') {
						callback.apply(self._element);
					}
				}, d);
			}
			return this;
		},
		// blur for changing focus from element
		blur: function () {
			if (this._element) {
				this._element.blur();
			}
			return this;
		},
		// focus element
		focus: function () {
			if (this._element) {
				this._element.focus();
			}
			return this;
		},
		// get and set props of element(s)
		prop: function (key, value) {
			if (this._element && key && typeof key === 'string' && value === void 0) {
				// get prop by key
				return this._element[key];
			} else if (this.length > 0 && key && (value !== void 0 || typeof key === 'object')) {
				// set prop for each element
				for (var i = 0; i < this._elements.length; i++) {
					var el = this._elements[i];
					if (typeof key === 'string') {
						// update individual prop value
						el[key] = value;
					} else if (typeof key === 'object') {
						// update each prop value
						for (var p in key) {
							el[p] = key[p];
						}
					}
				}
			}

			return this;
		},
		// get and set attributes of element(s)
		attr: function (key, value) {
			if (this._element && key && typeof key === 'string' && value === void 0) {
				// get attribute by key
				return this._element.getAttribute(key) || '';
			} else if (this.length > 0 && key && (value !== void 0 || typeof key === 'object')) {
				// set attribute for each element
				for (var i = 0; i < this._elements.length; i++) {
					var el = this._elements[i];
					if (typeof key === 'string') {
						// update individual attribute value
						el.setAttribute(key, value);
					} else if (typeof key === 'object') {
						// update each attribute value
						for (var p in key) {
							el.setAttribute(p, key[p]);
						}
					}
				}
			}

			return this;
		},
		// get all attributes
		allAttr: function (prefix, includePrefix) {
			var attr = {}, include = includePrefix !== false;
			if (this._element) {
				// build list of all attributes
				for (var i = 0; i < this._element.attributes.length; i++) {
					var a = this._element.attributes[i];
					// check for subset of attributes by prefix
					if (a.name.startsWith(prefix)) {
						var n = include ? a.name : a.name.replace(prefix, '');
						attr[n] = a.value;
					}
				}
			}

			return attr;
		},
		// get and set data props of element(s)
		data: function (key, value) {
			if (key === void 0) {
				// get all data attribute values on element
				var d = this.allAttr('data-', false);
				if (this._element && this._element.data) {
					// append all data props added to element
					for (var p in this._element.data) {
						d[p] = this._element.data[p];
					}
				}
				return d;
			} else if (value === void 0 && this._element) {
				// get data prop values added to element
				if (!this._element.data) {
					this._element.data = {};
				}
				// get current data prop value by key
				var val = this._element.data[key];
				if (val === void 0 && this._element.hasAttribute('data-'+key)) {
					// check for data-attribute and add as a prop
					val = this.attr('data-'+key);
					// try to parse value
					try { val = JSON.parse(val); } 
					catch (err) { }
					this._element.data[key] = val;
				}
				
				return val;
			} else if (this._element) {
				// update data prop by key
				if (!this._element.data) {
					this._element.data = {};
				}
				this._element.data[key] = value;
				return this;
			}
		},
		// get and set aria attributes
		aria: function (key, value) {
			if (key === void 0) {
				// get all aria attribute values
				return this.allAttr('aria-');
			} else if (value === void 0) {
				// get aria attribute by key
				return this.attr('aria-'+key);
			} else {
				// update aria attribute value
				return this.attr('aria-'+key, value);
			}
		},
		// simple get and set element value
		slxVal: function(newval) {
			if (newval === void 0) {
				// get value
				if (this.length === 0) {
					return null;
				}

				return this[0].value || '';
			} else {
				// set value for each element
				for (var i = 0; i < this.length; i++) {
					var el = this[i];
					el.value = newval;
				}
			}
			
			return this;
		},
		// get and set value in SLX control
		val: function(v1, v2) {
			// check for initialized SLX control
			var ctrl = this.isSlxControl() ? this.slxControl() : null;

			if (v1 === void 0) {
				// get current value
				if (ctrl !== null) { return ctrl.value(); }
				else { return this.slxVal(); }
			} else {
				// set value
				if (ctrl !== null) {
					ctrl.value.apply(ctrl, arguments);
					return this;
				} else {
					return this.slxVal(v1);
				}
			}
		},
		// get and set inner HTML of element
		html: function(val) {
			if (val === void 0) {
				// get inner HTML
				if (!this._element) {
					return null;
				}

				return this._element.innerHTML;
			} else {
				// set inner HTML for all elements
				for (var i = 0; i < this._elements.length; i++) {
					var el = this._elements[i];
					el.innerHTML = val;
				}
			}

			return this;
		},
		// simple get and set of inner text
		slxText: function(val) {
			if (val === void 0) {
				// get inner text
				if (this.length === 0) {
					return null;
				}

				return this[0].innerText;
			} else {
				// set inner text of all elements
				for (var i = 0; i < this.length; i++) {
					var el = this[i];
					el.innerText = val;
				}
			}

			return this;
		},
		// get and set inner text for SLX control
		text: function (v1, v2) {
			// check for initialized SLX control
			var ctrl = this.isSlxControl() ? this.slxControl() : null;
			if (v1 !== void 0) {
				// set inner text
				if (ctrl !== null) { ctrl.text.apply(ctrl, arguments); return this; }
				else { return this.slxText(v1); }
			} else {
				// get inner text
				if (ctrl !== null) { return ctrl.text(); }
				else { return this.slxText(); }
			}
		},
		// match selector for element
		is: function (selector) {
			if (!this._element) {
				return false;
			}
			
			var match = true;
			// validate visibility
			if (selector.indexOf(':visible') > -1) {
				selector = selector.replace(':visible', '').trim();

				// test visible by offset sizes
				if (selector.length === 0) {
					match = this._element.offsetWidth > 0 || this._element.offsetHeight > 0;
				}
			}

			// match selector
			return match && (selector.length === 0 || this._element.matches(selector));
		},
		// find child element by selector
		find: function (selector) {
			if (!this._element) {
				return this;
			}

			return SlxControl(selector, this._element);
		},
		// find element index
		index: function () {
			if (!this._element) {
				return -1;
			}

			return [].indexOf.call(this._element.parentNode.children, this._element);
		},
		// find closest parent element by selector
		closest: function (selector) {
			if (!this._element) {
				return this;
			}

			// slx default props
			var slx = {
				selector: selector,
				_elements: [],
				_element: this._element.closest(selector)
			};

			// add single element to array
			if (slx._element) {
				slx._elements.push(slx._element);
			}
	
			// convert ojbect to array and merge props
			var arr = [];
			SlxControl.extend(arr, SlxControl.slx);
			Array.prototype.push.apply(arr, slx._elements);
			
			return SlxControl.extend(arr, slx);
		},
		// trigger tooltips
		tooltip: function () {
			return this;
		},
		// get or generate unique id
		slxUniqueId: function () {
			return this.prop('id') || this.attr('id', 'slx' + SlxControl.slxGuid().segment(4)).prop('id');
		},
		// get initialized SLX control for element
		slxControl: function (control) {
			var slx = null, target = this;
			if (this.length > 0 && this.data('target')) { target = SlxControl(this.data('target')); }
			if (target.length > 0) {
				// locate initialized control
				if (control !== void 0 && target[0][control] !== void 0) { slx = target[0][control]; }
				else if (control === void 0) {
					for (var p in target[0]) {
						// get first control
						if (!p.startsWith('slx')) { continue; }
						slx = target[0][p];
						break;
					}
				}
			}

			return slx;
		},
		// validate if element has initialized SLX control
		isSlxControl: function () { return this.length ? this[0].isSlxControl !== void 0 : false; },
		// stop event bubbling up the chain
		stopBubble: function (e) {
			if (e.stopPropagation) { e.stopPropagation(); }
			else { e.cancelBubble = true; }
			return this;
		},
		// get cursor selection range
		getSelectionRange: function () {
			if (this.length === 0) { return null; }
			var el = this[0];
			if (el.selectionStart !== void 0) { return { start: el.selectionStart, end: el.selectionEnd }; }
			return null;
		},
		// set cursor selection range
		setSelectionRange: function (start, end) {
			if (this.length === 0) { return; }
			var el = this[0];
			if (el.selectionStart !== void 0) {
				// modern browsers
				el.focus();
				el.setSelectionRange(start, end);
			} else if (el.createTextRange !== void 0) {
				// old browsers
				var r = el.createTextRange();
				r.moveStart('character', start);
				r.moveEnd('character', end);
				r.select();
			} else { el.focus(); }
		},
		// validate if element has CSS class
		hasClass: function (cssClass, context) {
			var el = context || this._element;
			return el && el.classList.contains(cssClass);
		},
		// add CSS class
		addClass: function (cssClass) {
			if (cssClass && this.length > 0) {
				var classes = cssClass.split(' ');
				// add CSS class for each element
				for (var i = 0; i < this._elements.length; i++) {
					var el = this._elements[i];
					// add each CSS class
					for (var j = 0; j < classes.length; j++) {
						var c = classes[j];
						if (!this.hasClass(c, el)) {
							el.classList.add(c);
						}
					}
				}
			}
			return this;
		},
		// remove CSS class
		removeClass: function (cssClass) {
			if (cssClass && this.length > 0) {
				var classes = cssClass.split(' ');
				// remove CSS class for each element
				for (var i = 0; i < this._elements.length; i++) {
					var el = this._elements[i];
					// remove each CSS class
					for (var j = 0; j < classes.length; j++) {
						var c = classes[j];
						if (this.hasClass(c, el)) {
							el.classList.remove(c);
						}
					}
				}
			}
			return this;
		},
		// get and set CSS properties
		css: function (prop, value) {
			var el;
			if (this.length === 0 || !prop) {
				return this;
			} else if (typeof prop === 'string' && value === void 0) {
				// get css property value
				el = this._element || this._elements[0];
				var cs = global.getComputedStyle(el);
				return cs.getPropertyValue(prop);
			}

			// set css inline props for each element
			for (var i = 0; i < this.length; i++) {
				el = this._elements[i];
				var s = el.getAttribute('style') || '';
				if (s.trim().length > 0 && s.indexOf(';') === -1) {
					s += ';';
				}
				var arr = s.split(';').filter(function(i) { return i; });
				var styles = {};
				// convert inline style string into styles collection
				for (var a = 0; a < arr.length; a++) {
					var p = arr[a].split(':');
					styles[p[0]] = (p[1] || '').trim();
				}

				if (typeof prop === 'string') {
					// set individual css prop
					styles[prop] = value;
				} else if (typeof prop === 'object') {
					// set each css prop
					for (var p in prop) {
						styles[p] = prop[p];
					}
				}

				// rebuild inline styles string and update element
				arr = [];
				for (var c in styles) {
					arr.push(c+':'+styles[c]);
				}
				el.setAttribute('style', arr.join(';'));
			}

			return this;
		},
		// animate by keyframes
		animate: function (keyframes, duration, easing, callback) {
			if (!this._element) {
				return this;
			}

			// animation default options
			var options = {
				duration: duration || 0,
				easing: easing || 'linear',
				iterations: 1
			};

			// build keyframes "from" starting point
			var from = {};
			var s = global.getComputedStyle(this._element);
			for (var p in keyframes) {
				from[p] = s[p];
			}

			// build keyframes array and do html5 animation
			var arr = [from, keyframes];
			this._element.animate(arr, options);

			// do callback
			if (typeof callback === 'function') {
				setTimeout(callback, duration);
			}
		},
		// get outer width of element
		outerWidth: function (includeMargins) {
			if (!this._element) {
				return null;
			}

			var w = this._element.offsetWidth;
			// include margin sizes
			if (includeMargins) {
				var s = global.getComputedStyle(this._element, null);
				w += parseInt(s.getPropertyValue('margin-left')) + parseInt(s.getPropertyValue('margin-right'));
			}

			return w;
		},
		// get outer height of element
		outerHeight: function (includeMargins) {
			if (!this._element) {
				return null;
			}

			var h = this._element.offsetHeight;
			// include margin sizes
			if (includeMargins) {
				var s = global.getComputedStyle(this._element, null);
				h += parseInt(s.getPropertyValue('margin-top')) + parseInt(s.getPropertyValue('margin-bottom'));
			}

			return h;
		},
		// get and set width of element
		width: function (value) {
			if (!this._element) {
				return null;
			}

			// set width
			if (value !== void 0) {
				var v = typeof value === "number" ? value + 'px' : value;
				return this.css('width', v);
			}

			// get width
			return this._element.clientWidth;
		},
		// get and set height of element
		height: function (value) {
			if (!this._element) {
				return null;
			}

			// set height
			if (value !== void 0) {
				var v = typeof value === "number" ? value + 'px' : value;
				return this.css('height', v);
			}

			// get height
			return this._element.clientHeight;
		},
		// get screen position of element
		position: function () {
			if (!this._element) {
				return this;
			}

			// get x and y coords
			return {
				top: this._element.offsetTop,
				left: this._element.offsetLeft
			};
		},
		// scroll element by top position
		scrollTop: function (top) {
			if (this._element) {
				if (typeof top === 'number') {
					// set scroll position
					this._element.scrollTop = top;
				} else if (top === void 0) {
					// get scroll position
					return this._element.scrollTop;
				}
			}

			return this;
		},
		// loop through each element
		each: function (callback) {
			if (this.length === 0 || typeof callback !== 'function') { return this; }
			// do callback for each element
			for (var i = 0; i < this._elements.length; i++) {
				var el = this._elements[i];
				callback.apply(el);
			}
			return this;
		},
		// get parent element
		parent: function () {
			if (this.length === 0) { return this; }
			return SlxControl.create(this._element.parentNode);
		},
		// get children elements
		children: function (selector) {
			if (this.length > 0) {
				return SlxControl(':scope > ' + (selector || '*'), this._element);
			}
			return SlxControl();
		},
		// get previous sibling element
		prev: function () {
			if (this._element) {
				var p = this._element.previousElementSibling;
				if (p) {
					return SlxControl(p);
				}
			}
			return this;
		},
		// get next sibling element
		next: function () {
			if (this._element) {
				var n = this._element.nextElementSibling;
				if (n) {
					return SlxControl(n);
				}
			}
			return this;
		},
		// get first element
		first: function () {
			if (this._elements.length > 0) {
				var n = this._elements[0];
				if (n) {
					return SlxControl(n);
				}
			}
			return this;
		},
		// get last element
		last: function () {
			if (this._elements.length > 0) {
				var n = this._elements[this._elements.length - 1];
				if (n) {
					return SlxControl(n);
				}
			}
			return this;
		},
		// wrap element within another element
		wrap: function (slx) {
			if (this.length === 0 || !slx || slx.length === 0) { return this; }
			var parent = this.parent();
			if (parent.length) {
				parent[0].insertBefore(slx[0], this._element);
				slx[0].appendChild(this._element);
			}
			return this;
		},
		// insert element before another element
		before: function (slx) {
			if (this.length === 0 || !slx || slx.length === 0) { return this; }
			var parent = this.parent();
			if (parent.length) {
				parent[0].insertBefore(slx[0], this._element);
			}
			return this;
		},
		// insert element after another element
		after: function (slx) {
			if (this.length === 0 || !slx || slx.length === 0) { return this; }
			var parent = this.parent(), next = this._element.nextSibling;
			if (parent.length) {
				if (next) {
					parent[0].insertBefore(slx[0], next);
				} else {
					parent[0].appendChild(slx[0]);
				}
			}
			return this;
		},
		// append element within this element
		append: function (slx) {
			if (this.length === 0 || !slx || slx.length === 0) { return this; }
			for (var i = 0; i < slx.length; i++) {
				this._element.appendChild(slx._elements[i]);
			}
			return this;
		},
		// prepend element within this element
		prepend: function (slx) {
			if (this.length === 0 || !slx || slx.length === 0) { return this; }
			for (var i = slx.length-1; i >= 0; i--) {
				this._element.insertBefore(slx._elements[i], this._element.childNodes[0]);
			}
			return this;
		},
		// clear out all children within this element
		empty: function () {
			if (this.length === 0) { return this; }
			this._element.innerHTML = '';
			return this;
		},
		// remove this element
		remove: function() {
			if (this.length === 0) { return this; }
			this._element.remove();
			return this;
		},
		// trigger event by name
		trigger: function (eventName) {
			if (this.length > 0 && eventName) {
				var event = new Event(eventName.split('.')[0], { bubbles: false, cancelable: false });
				this._element.dispatchEvent(event);
			}
			return this;
		},
		// trigger event with custom data
		triggerHandler: function (eventName, data) {
			if (this.length > 0 && eventName) {
				var event = new CustomEvent(eventName, { bubbles: false, cancelable: false, detail: data });
				this._element.dispatchEvent(event);
			}
			return this;
		},
		// add event listener
		on: function (eventName, handler) {
			if (this.length === 0 || !eventName || typeof handler !== 'function') { return this; }
			// add event for each element
			for (var i = 0; i < this._elements.length; i++) {
				var el = this._elements[i];
				if (!el.eventList) {
					el.eventList = {};
				}

				// register event by namespace
				if (!el.eventList[eventName]) {
					el.eventList[eventName] = handler;
					el.addEventListener(eventName.split('.')[0], handler, false);
				}
			}
			return this;
		},
		// remove event listener
		off: function (eventName) {
			if (this.length === 0 || !eventName) { return this; }
			// remove event for each element
			for (var i = 0; i < this._elements.length; i++) {
				var el = this._elements[i];
				// unregister event by namespace
				if (el.eventList && el.eventList[eventName]) {
					el.removeEventListener(eventName.split('.')[0], el.eventList[eventName], false);
					delete(el.eventList[eventName]);
				}
			}
			return this;
		}
	});

	// static extensions
	SlxControl.extend({
		// register control
		register: function(control, instance) {
			if (typeof instance === 'function' && typeof SlxControl[control] !== 'function') {
				SlxControl[control] = instance;
			}
		},
		// create element by tag name
		create: function (tagName) {
			if (!tagName) { return SlxControl(); }

			var el;
			
			// determine element
			if (typeof tagName === 'string') {
				// create new element
				var name = tagName.split(' ')[0].replace(/[<\/>]/g, '').toUpperCase();
				el = document.createElement(name);
			} else if (typeof tagName === 'object') {
				// using supplied element
				el = tagName;
			}

			// instance props
			var slx = {
				selector: null,
				_elements: [el],
				_element: el
			};
	
			// convert to array and merge props
			var arr = [];
			SlxControl.extend(arr, SlxControl.slx);
			Array.prototype.push.apply(arr, slx._elements);
			
			return SlxControl.extend(arr, slx);
		},
		// loop through each item in array
		each: function (arr, callback) {
			if (!arr || arr.length === 0 || typeof callback !== 'function') { return; }
			// do callback for each item
			for (var i = 0; i < arr.length; i++) {
				callback.call(this, i, arr[i]);
			}
		},
		// html encode string
		htmlEncode: function (a) {
			if (typeof a !== 'string') { return ''; }
			return a.replace(/[<]/g, '&lt;').replace(/[>]/g, '&gt;');
		},
		// convert string to camelCase
		slxCamelCase: function (a) {
			return a.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
				if (+match === 0) return ''; // or if (/\s+/.test(match)) for white spaces
				return index === 0 ? match.toLowerCase() : match.toUpperCase();
			});
		},
		// convert strings, arrays, and objects to camelCase
		camelCase: function (a) {
			if (a === null || a === void 0) { return null; }
			if (typeof a === 'string') { return SlxControl.slxCamelCase(a); }
	
			// validate if array or object
			var isArr = Array.isArray(a), isObj = typeof a === 'object';
			if (!isArr && !isObj) { return a; }
	
			// convert whole array
			if (isArr) {
				var arr = new Array();
				for (var i = 0; i < a.length; i++) { arr.push(SlxControl.camelCase(a[i])); }
				return arr;
			}
	
			// convert whole object
			var obj = {};
			for (var p in a) {
				if (!a.hasOwnProperty(p)) { continue; }
	
				var prop = SlxControl.slxCamelCase(p);
				prop = prop.substr(0, 1).toLowerCase() + prop.substr(1);
				obj[prop] = Array.isArray(a[p]) || typeof a[p] === 'object' ? SlxControl.camelCase(a[p]) : a[p];
			}
			return obj;
		},
		// ajax handler
		ajax: function (settings) {
			// build request object
			var request = new XMLHttpRequest();
			var dataType = (settings.dataType || 'text').toLowerCase();
			// handle async calls
			var async = settings.async !== false;
			if (async) {
				request.responseType = dataType;
			}
			// open connection and set headers
			request.open(settings.type, settings.url, async);
			request.setRequestHeader('Content-type', settings.contentType);
			if (settings.cache === false) {
				request.setRequestHeader('Cache-Control', 'no-cache, no-store, max-age=0');
				request.setRequestHeader('Expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
				request.setRequestHeader('Pragma', 'no-cache');
			}
			// state change handler
			request.onreadystatechange = function () {
				if (request.readyState === 4 && request.status === 200 && typeof settings.success === 'function') {
					// ready state and success callback
					var data = request.responseType !== dataType && dataType === 'json' ? JSON.parse(request.response) : request.response;
					settings.success.call(this, data);
				} else if (request.readyState === 4 && typeof settings.error === 'function') {
					// ready w/ errors and error callback
					var err = {
						status: request.status,
						statusText: request.statusText,
						responseText: request.responseText
					};
					settings.error.call(this, err, request.statusText);
				}
			};
			// do ajax call
			request.send(settings.data);
		},
		// slx safe eval
		eval: function (code) {
			// ensure that there is code to evaluate
			if (!code) {
				return null;
			}

			// remove javascript prefix, if added
			var js = code.replace('javascript:', '');
			
			// check for function call and add context
			var index = js.search(/(\()[a-zA-Z]{0,}(\))[\;]{0,}$/g);
			if (index > 0 && this !== global) {
				js = js.slice(0, index) + '.call(this, ' + js.slice(index + 1);
			}

			// add all additional arguments to function
			var args = Array.prototype.slice.call(arguments, 1);
			return new Function(args, js);
		}
	});

	/*
	 * slx.base
	 * This is the base level object for all slxControls.
	 */
	SlxControl.slx.base = function (elem) {
		var that = this;
		var el = elem;

		// initialize base settings from data attributes
		if (el === void 0) { return this; }
		if (el.data('target')) {
			el = el.find(el.data('target'));
			if (el.length === 0) { return el; }
		}

		// get current element and merge settings
		that._element = el;
		that.toString = function () { return '[' + that.constructor.name + ']'; };
		return SlxControl.extend(that, arguments.length === 2 && typeof arguments[1] !== 'string' ? arguments[1][0] || arguments[1] : {});
	};

	// guid queue
	var _guids = new Array();
	// guid generator class
	var Guid = function () {
		// guid parts generator
		var _part = function () { return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1); };
		var _guid = (_part() + _part() + '-' + _part() + '-4' + _part().substring(0, 3) + '-' + _part() + '-' + _part() + _part() + _part()).toLowerCase();

		var that = this;
		// convert guid to string
		that.toString = function () { return _guid; };
		// get guid segment
		that.segment = function (i) { return _guid.split('-')[i]; };

		// regenerate if already queued
		if (_guids.findIndex(function (g) { return g.split('-')[4] === that.segment(4); }) > -1) { return new Guid(); }
		_guids.push(_guid);
	};

	// static extensions
	SlxControl.extend({
		// add guid extension to core
		slxGuid: function () {
			return new Guid();
		}
	});

	return global.SlxControl = SlxControl;
})(window || this);